import * as React from 'reactn';
import {
    base,
    Route,
    IBaseProps, BaseColor, DialogUtil, StringUtil, ArrayUtil, ComponentFactory
} from 'oca-lib-web'
import {createRef} from "react";
import Sidebar from "../component/Sidebar";
import DatasourceDialog from "../component/DatasourceDialog";
import SocialUtil from "../util/SocialUtil";
import Styles from "../style/Styles";
import VisualUtil from "../util/VisualUtil";

interface IState {
    componentFactory:ComponentFactory,
    dialogs:Array<any>,
    project?: ProjectModel,
    dataSources?: Array<DataSource>
    currentIndex: number
}

class ProjectPage extends React.PureComponent<IBaseProps, IState> {

    public dataSourceDialog = createRef<any>();

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);

        let dialogs = [
            <DatasourceDialog {...componentFactory.renderDialogProps("Data Source", "Save", this.dataSourceCallback.bind(this), this.dataSourceDialog)} />,
        ]

        this.state = {
            componentFactory:componentFactory,
            dialogs:dialogs,
            currentIndex: 0,
            dataSources: []
        }
    }

    async componentDidMount() {
        let id = Route.param(this, 'id');

        let project = null;
        if (id) {
            project = await this.global.dataManager.get("getProject", id);
            let dataSources = await this.global.dataManager.get("getDataSources", id);
            ArrayUtil.sort(dataSources, "dataSourceName");
            this.setState({project:project, dataSources:dataSources});
        } else {
            this.setState({project:{}});
        }

        this.state.componentFactory.addDefaultBinding(this.global.dataManager, "createProject", project);
        this.forceUpdate();
    }

    async uploadGooglePlayServiceKeyFile(e:any) {
        console.log("google play service key");

        let results = await this.uploadData(e, true);
        let googlePrivateKey = results["private_key"];
        let googleClientEmail = results["client_email"];

        let project = this.state.project;
        project.googlePrivateKey = googlePrivateKey;
        project.googleClientEmail = googleClientEmail;

        this.setState({project:project});
    }

    async uploadPushNotificationServiceKeyFile(e:any) {

        console.log("uploadPushNotificationServiceKeyFile");
        let results = await this.uploadData(e, true);
        let projectId = results["project_id"];
        let pushPrivateKey = results["private_key"];
        let pushClientEmail = results["client_email"];

        console.log("Got push notification service key: " + projectId + " " + pushClientEmail);

        let project = this.state.project;
        project.pushProjectId = projectId;
        project.pushPrivateKey = pushPrivateKey;
        project.pushClientEmail = pushClientEmail;

        this.setState({project:project});
    }

    async uploadAPNSAuthenticationKey(e:any) {
        console.log("apns service key");

        let results = await this.uploadData(e, false);
        console.log(results);

        let project = this.state.project;
        project.applePushPrivateKey = results;
        this.setState({project:project});
    }

    async uploadData(e:any, isJSON:boolean):Promise<any> {
        if (!e.nativeEvent.target || !e.nativeEvent.target.files) { return }

        const file = e.nativeEvent.target.files[0];

        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsText(file, "UTF-8");
            reader.onload = function (evt:any) {
                if (isJSON) {
                    let results = JSON.parse(evt.target.result);
                    resolve(results);
                } else {
                    resolve(evt.target.result);
                }
            }
        });
    }

    async saveProject() {
        let project = this.state.project;
        if (!project["id"]) {
            project["id"] = StringUtil.uuid();
        }
        if (!project["identityId"]) {
            project["identityId"] = this.global.user.id;
        }

        console.log(project);
        await this.global.dataManager.save("createProject", project);

        //Route.goBack(this);
        this.props.base.notify("Project saved successfully");
    }

    async dataSourceDeleted(item:any) {
        console.log(item);
        await this.global.dataManager.delete("deleteDataSource", item.dataSource);

        let dataSources = await this.global.dataManager.get("getDataSources", this.state.project.id);
        ArrayUtil.sort(dataSources, "dataSourceName");
        this.setState({dataSources:dataSources});

        this.props.base.notify("Datasource deleted");
    }

    async dataSourceCallback() {
        let dataSources = await this.global.dataManager.get("getDataSources", this.state.project.id);
        ArrayUtil.sort(dataSources, "dataSourceName");
        this.setState({dataSources:dataSources});
    }

    deleteProject() {
        this.props.base.alert("Confirm Delete", "Are you sure you want to delete " + this.state.project.projectName + "? This action cannot be undone.", this.deleteProjectCallback.bind(this), this.state.project)
    }

    async deleteProjectCallback() {
        await this.global.dataManager.delete("deleteProject", this.state.project);
        Route.goBack(this);
    }

    getDataSourceRow(item:DataSource) {
        /*const actionLink = <Box>
            <IconButtonComponent icon={BaseIcon.ICON_DELETE} tooltip="Delete" color="secondary" onTouchTap={DialogUtil.openFunction(this.alertDialog.current, item)} />
        </Box>*/
        let editFunction = DialogUtil.openFunction(this.dataSourceDialog.current, item);
        let deleteFunction = () => this.props.base.alert("Confirm Delete", "Are you sure you want to delete this data source? This action cannot be undone.", this.dataSourceDeleted.bind(this),
            {projectId:this.state.project?.id, dataSource:item});
        let actions = this.state.componentFactory.renderEditDeleteButtons(editFunction,deleteFunction);

        let dataSourceName = item.dataSourceName;
        if (dataSourceName == "custom") {
            let params = JSON.parse(item.params);
            dataSourceName += " - " + params.dataSourceName;
        }
        return [
            dataSourceName,
            actions
        ];
    }

    renderPushNotificationDetails() {
        const cf = this.state.componentFactory;
        return (
            cf.renderBoxProps({marginTop:'0px'}, [
                VisualUtil.getHeaderDisplay("Push Notifications"),
                cf.renderLine(),
                cf.renderBoxPadded(cf.renderTextField("applePushKeyId", "Apple Push Key Id")),
                cf.renderBoxPadded(cf.renderTextField("applePushPrivateKey", "Apple Push Private Key")),
                cf.renderBoxPadded(cf.renderTextField("pushClientEmail", "FCM Client Email")),
                cf.renderBoxPadded(cf.renderTextField("pushDatabaseUrl", "FCM Database Url")),
                cf.renderBoxPadded(cf.renderTextField("pushNotificationTokenUrl", "Push Notification Token Url")),
                cf.renderBoxPadded(cf.renderTextField("pushNotificationAppTargetUrl", "Push Notification App Target Url")),
            ])
        )
    }

    render() {
        const cf = this.state.componentFactory;
        const actions = [
            cf.renderButton("Connect LinkedIn", (e:any) => {
                window.location.href = SocialUtil.getAuthorizationUrl();
            }, {isFlat:true}),
            cf.renderButton("New", (e:any) => DialogUtil.open(this.dataSourceDialog.current, {projectId:this.state.project?.id}))
        ]
        return cf.renderBoxProps({fullHeight:true, background:BaseColor.WHITE},[
            this.state.dialogs,
            cf.renderBoxProps({marginLeft:'70px'}, [
                VisualUtil.getHeaderDisplay("Project Details", [
                    cf.renderButton("Save", this.saveProject.bind(this)),
                    cf.renderButton("Delete", this.deleteProject.bind(this), {style:{marginLeft:'20px'}, isFlat:true, primary:false, secondary:true})
                ]),
                cf.renderLine(),
                cf.renderBoxPadded(cf.renderTextField("projectName", "Project Name")),
                cf.renderLine(),
                this.renderPushNotificationDetails(),
                cf.renderLine(),
                VisualUtil.getHeaderDisplay("Datasources", actions),
                cf.renderTable(["Datasource", "Actions"], this.state.dataSources, this.getDataSourceRow.bind(this))
            ])
        ]);
    }
}

export default base(ProjectPage, Sidebar)